import Pager from './pagination.vue';

export default {
    name: 'poi-pagination',
    props: {
        pageSize: {
            type: Number,
            default: 10
        },

        small: Boolean,

        total: Number,

        pageCount: Number,

        pagerCount: {
            type: Number,
            validator(value) {
                return (value | 0) === value && value > 4 && value < 22 && (value % 2) === 1;
            },
            default: 7
        },

        currentPage: {
            type: Number,
            default: 1
        },

        layout: {
            default: 'prev, pager, next, jumper, ->, total'
        },

        pageSizes: {
            type: Array,
            default() {
                return [10, 20, 30, 40, 50, 100];
            }
        },

        popperClass: String,

        prevText: String,

        nextText: String,

        background: Boolean,

        disabled: Boolean
    },

    data() {
        return {
            internalCurrentPage: 1,
            internalPageSize: 0,
            lastEmittedPage: -1,
            userChangePageSize: false
        };
    },

    render(h) {
        let template = <div class={['poi-pagination', {
            'is-background': this.background,
            'poi-pagination--small': this.small
        }]}></div>;
        const layout = this.layout || '';
        if (!layout) return;
        const TEMPLATE_MAP = {
            prev: <prev></prev>,
            jumper: <jumper></jumper>,
            pager: <pager currentPage={this.internalCurrentPage} pageCount={this.internalPageCount} pagerCount={this.pagerCount} on-change={this.handleCurrentChange} disabled={this.disabled}></pager>,
            next: <next></next>,
            sizes: <sizes pageSizes={this.pageSizes}></sizes>,
            slot: <my-slot></my-slot>,
            total: <total></total>
        };
        const components = layout.split(',').map((item) => item.trim());
        const rightWrapper = <div class="poi-pagination__rightwrapper"></div>;
        let haveRightWrapper = false;

        template.children = template.children || [];
        rightWrapper.children = rightWrapper.children || [];
        components.forEach(compo => {
            if (compo === '->') {
                haveRightWrapper = true;
                return;
            }

            if (!haveRightWrapper) {
                template.children.push(TEMPLATE_MAP[compo]);
            } else {
                rightWrapper.children.push(TEMPLATE_MAP[compo]);
            }
        });

        if (haveRightWrapper) {
            template.children.unshift(rightWrapper);
        }

        return template;
    },

    components: {
        MySlot: {
            render(h) {
                return (
                    this.$parent.$slots.default
                        ? this.$parent.$slots.default[0]
                        : ''
                );
            }
        },
        Prev: {
            render(h) {
                return (
                    <button
                        type="button"
                        class="btn-prev"
                        disabled={this.$parent.disabled || this.$parent.internalCurrentPage <= 1}
                        on-click={this.$parent.prev}>
                        {
                            this.$parent.prevText
                                ? <span>{this.$parent.prevText}</span>
                                : <i class="iconfont poi-icon-left"></i>
                        }
                    </button>
                );
            }
        },

        Next: {
            render(h) {
                return (
                    <button
                        type="button"
                        class="btn-next"
                        disabled={this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0}
                        on-click={this.$parent.next}>
                        {
                            this.$parent.nextText
                                ? <span>{this.$parent.nextText}</span>
                                : <i class="iconfont poi-icon-right"></i>
                        }
                    </button>
                );
            }
        },

        Sizes: {
            //   mixins: [Locale],
            props: {
                pageSizes: Array
            },

            watch: {
                pageSizes: {
                    immediate: true,
                    handler(newVal, oldVal) {
                        if (valueEquals(newVal, oldVal)) return;
                        if (Array.isArray(newVal)) {
                            this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1
                                ? this.$parent.pageSize
                                : this.pageSizes[0];
                        }
                    }
                }
            },

            render(h) {
                return (
                    <span class="poi-pagination__sizes">
                        <poi-select
                            value={this.$parent.internalPageSize}
                            popperClass={this.$parent.popperClass || ''}
                            size="mini"
                            on-input={this.handleChange}
                            disabled={this.$parent.disabled}>
                            {
                                this.pageSizes.map(item =>
                                    <poi-option
                                        value={item}
                                        label={item+' 条/页'}>
                                    </poi-option>
                                )
                            }
                        </poi-select>
                    </span>
                );
            },

            components: {
                //select
                // ElSelect,
                // ElOption
            },

            methods: {
                handleChange(val) {
                    if (val !== this.$parent.internalPageSize) {
                        this.$parent.internalPageSize = val = parseInt(val, 10);
                        this.$parent.userChangePageSize = true;
                        this.$parent.$emit('update:pageSize', val);
                        this.$parent.$emit('size-change', val);
                    }
                }
            }
        },

        Jumper: {
            //   mixins: [Locale],

            data() {
                return {
                    oldValue: null
                };
            },

            //   components: { ElInput },

            watch: {
                '$parent.internalPageSize'() {
                    this.$nextTick(() => {
                        this.$refs.input.$el.querySelector('input').value = this.$parent.internalCurrentPage;
                    });
                }
            },

            methods: {
                handleFocus(event) {
                    this.oldValue = event.target.value;
                },
                handleBlur({ target }) {
                    this.resetValueIfNeed(target.value);
                    this.reassignMaxValue(target.value);
                },
                handleKeyup({ keyCode, target }) {
                    if (keyCode === 13 && this.oldValue && target.value !== this.oldValue) {
                        this.handleChange(target.value);
                    }
                },
                handleChange(value) {
                    this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
                    this.$parent.emitChange();
                    this.oldValue = null;
                    this.resetValueIfNeed(value);
                },
                resetValueIfNeed(value) {
                    const num = parseInt(value, 10);
                    if (!isNaN(num)) {
                        if (num < 1) {
                            this.$refs.input.setCurrentValue(1);
                        } else {
                            this.reassignMaxValue(value);
                        }
                    }
                },
                reassignMaxValue(value) {
                    const { internalPageCount } = this.$parent;
                    if (+value > internalPageCount) {
                        this.$refs.input.setCurrentValue(internalPageCount || 1);
                    }
                }
            },

            render(h) {
                return (
                    <span class="poi-pagination__jump">
                        前往
                        <poi-input
                            class="poi-pagination__editor is-in-pagination"
                            min={1}
                            max={this.$parent.internalPageCount}
                            value={this.$parent.internalCurrentPage}
                            domPropsValue={this.$parent.internalCurrentPage}
                            type="number"
                            ref="input"
                            disabled={this.$parent.disabled}
                            nativeOnKeyup={this.handleKeyup}
                            onChange={this.handleChange}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur} />
                            页
                    </span>
                );
            }
        },

        Total: {
            //   mixins: [Locale],

            render(h) {
                return (
                    typeof this.$parent.total === 'number'
                        ? <span class="poi-pagination__total">共 {this.$parent.total} 条</span>
                        : ''
                );
            }
        },

        Pager
    },

    methods: {
        handleCurrentChange(val) {
            this.internalCurrentPage = this.getValidCurrentPage(val);
            this.userChangePageSize = true;
            this.emitChange();
        },

        prev() {
            if (this.disabled) return;
            const newVal = this.internalCurrentPage - 1;
            this.internalCurrentPage = this.getValidCurrentPage(newVal);
            this.$emit('prev-click', this.internalCurrentPage);
            this.emitChange();
        },

        next() {
            if (this.disabled) return;
            const newVal = this.internalCurrentPage + 1;
            this.internalCurrentPage = this.getValidCurrentPage(newVal);
            this.$emit('next-click', this.internalCurrentPage);
            this.emitChange();
        },

        getValidCurrentPage(value) {
            value = parseInt(value, 10);

            const havePageCount = typeof this.internalPageCount === 'number';

            let resetValue;
            if (!havePageCount) {
                if (isNaN(value) || value < 1) resetValue = 1;
            } else {
                if (value < 1) {
                    resetValue = 1;
                } else if (value > this.internalPageCount) {
                    resetValue = this.internalPageCount;
                }
            }

            if (resetValue === undefined && isNaN(value)) {
                resetValue = 1;
            } else if (resetValue === 0) {
                resetValue = 1;
            }

            return resetValue === undefined ? value : resetValue;
        },

        emitChange() {
            this.$nextTick(() => {
                if (this.internalCurrentPage !== this.lastEmittedPage || this.userChangePageSize) {
                    this.$emit('current-change', this.internalCurrentPage);
                    this.lastEmittedPage = this.internalCurrentPage;
                    this.userChangePageSize = false;
                }
            });
        }
    },

    computed: {
        internalPageCount() {
            if (typeof this.total === 'number') {
                return Math.ceil(this.total / this.internalPageSize);
            } else if (typeof this.pageCount === 'number') {
                return this.pageCount;
            }
            return null;
        }
    },

    watch: {
        currentPage: {
            immediate: true,
            handler(val) {
                this.internalCurrentPage = val;
            }
        },

        pageSize: {
            immediate: true,
            handler(val) {
                this.internalPageSize = isNaN(val) ? 10 : val;
            }
        },

        internalCurrentPage: {
            immediate: true,
            handler(newVal, oldVal) {
                newVal = parseInt(newVal, 10);

                /* istanbul ignore if */
                if (isNaN(newVal)) {
                    newVal = oldVal || 1;
                } else {
                    newVal = this.getValidCurrentPage(newVal);
                }

                if (newVal !== undefined) {
                    this.internalCurrentPage = newVal;
                    if (oldVal !== newVal) {
                        this.$emit('update:currentPage', newVal);
                    }
                } else {
                    this.$emit('update:currentPage', newVal);
                }
                this.lastEmittedPage = -1;
            }
        },

        internalPageCount(newVal) {
            /* istanbul ignore if */
            const oldPage = this.internalCurrentPage;
            if (newVal > 0 && oldPage === 0) {
                this.internalCurrentPage = 1;
            } else if (oldPage > newVal) {
                this.internalCurrentPage = newVal === 0 ? 1 : newVal;
                this.userChangePageSize && this.emitChange();
            }
            this.userChangePageSize = false;
        }
    }
};

function valueEquals(a, b) {
    if (a === b) return true;
    if (!(a instanceof Array)) return false;
    if (!(b instanceof Array)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i !== a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
};
